// Fire-and-forget gameplay analytics. Posts a tiny event to the worker so we can
// see the playtest funnel (opens, logins, tutorial completion, first harvest,
// wave progress, deaths). Never blocks or throws; failures are ignored.

import { API_BASE, getToken } from './api';

const ANON_KEY = 'gokturk.anon';

/** A persistent anonymous id so pre-login events still tie to a person. */
function anonId(): string {
  try {
    let a = localStorage.getItem(ANON_KEY);
    if (!a) {
      a = 'a' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem(ANON_KEY, a);
    }
    return a;
  } catch {
    return 'anon';
  }
}

export function track(name: string, props?: Record<string, unknown>): void {
  try {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const token = getToken();
    if (token) headers['Authorization'] = 'Bearer ' + token;
    void fetch(API_BASE + '/event', {
      method: 'POST',
      headers,
      body: JSON.stringify({ name, anon: anonId(), props }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
